import { render } from "./zhudanmingxi.vue?vue&type=template&id=589c7856"
import script from "./zhudanmingxi.vue?vue&type=script&lang=js"
export * from "./zhudanmingxi.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\33043\\Desktop\\new\\pc_admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__